import React from "react";
import { Container } from "reactstrap";
import styled from "styled-components";
import PropTypes from "prop-types";

import { HeaderButton } from "../../components/Buttons";
import { theme } from "../../constants/theme";
import { BLUE_BACKGROUND_COLOR } from "../../constants/colors";

const Title = styled.h2`
  font-family: ${theme.font.display};
  font-weight: 500;
  font-size: clamp(1.75rem, 2.5vw + 1rem, 2.75rem);
  letter-spacing: -0.025em;
  line-height: 1.1;
  max-width: 80%;
  color: ${({ color }) => color};
  width: ${({ width }) => width};
  font-weight: ${({ fontWeight }) => fontWeight || theme.weight.semibold};
  text-wrap: balance;
  font-variation-settings: "opsz" 96;
`;

const SectionContainer = styled.div`
  background-color: ${({ bgColor }) => bgColor};
  color: #fff;
  padding: ${({ padding }) => padding || "3rem 0"};
  margin: ${({ margin }) => margin};
`;

const LandingPageSection = ({
  buttonText,
  titleText,
  bgColor,
  children,
  sectionStyles,
  titleStyles,
  onButtonClick,
}) => (
  <SectionContainer
    className="section text-center"
    bgColor={bgColor}
    {...sectionStyles}
  >
    <Container>
      {titleText && (
        <Title className="title ml-auto mr-auto" {...titleStyles}>
          {titleText}
        </Title>
      )}
      {buttonText && (
        <HeaderButton className="ml-auto mr-auto" onClick={onButtonClick}>
          {buttonText}
        </HeaderButton>
      )}
      {children}
    </Container>
  </SectionContainer>
);

LandingPageSection.propTypes = {
  buttonText: PropTypes.string,
  titleText: PropTypes.node,
  bgColor: PropTypes.string,
  children: PropTypes.node,
  sectionStyles: PropTypes.object,
  titleStyles: PropTypes.object,
  onButtonClick: PropTypes.func,
};

LandingPageSection.defaultProps = {
  bgColor: BLUE_BACKGROUND_COLOR,
  titleStyles: {
    color: "#FDFBF7",
  },
};

export default LandingPageSection;
